module.exports = __webpack_public_path__ + "static/media/1009831.6a607429.jpg";